import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { CurrenciesActions } from "./currencies.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// CURRENCIES REDUCER
// Handles operation states only - data is in application/data store
// **************************************************************************

const updateCurrency = on(CurrenciesActions.updateCurrency, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    currencies: { ...superUserState.currencies, updating: true },
    error: null,
})));

const updateCurrencySuccess = on(CurrenciesActions.updateCurrencySuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    currencies: { ...superUserState.currencies, updating: false },
    error: null,
})));

const updateCurrencyFailure = on(CurrenciesActions.updateCurrencyFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    currencies: { ...superUserState.currencies, updating: false },
    error,
})));

export const currenciesReducer = [
    updateCurrency,
    updateCurrencySuccess,
    updateCurrencyFailure,
];
